import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../Components/Login/services/authSlice';
import profileReducer from "../Components/pages/AdminProfile/services/profileSlice";
import categoryReducer from "../Components/pages/Category/services/categorySlice";
import productReducer from "../Components/pages/Product/services/productSlice";
import transactionReducer from '../Components/pages/Transaction/services/transactionSlice';
import customerReducer from '../Components/pages/Customer/services/customerSlice';
import orderReducer from '../Components/pages/Order/services/orderSlice';
import supportReducer from '../Components/pages/Support/services/supportSlice';
import faqReducer from '../Components/pages/FAQs/services/faqSlice';
import policyReducer from '../Components/pages/Policies/services/policySlice';
import contactReducer from '../Components/pages/Contact/services/contactSlice';
import collectionReducer from '../Components/pages/Collection/services/collectionSlice';
import promoBannerReducer from '../Components/pages/PromoBanner/services/promoBannerSlice';
import courierReducer from '../Components/pages/Order/services/courierSlice';
import watchBuyReducer from '../Components/pages/Watchbuy/services/watchBuySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    category: categoryReducer,
    product: productReducer,
    transaction: transactionReducer,
    customer: customerReducer,
    order: orderReducer,
    support: supportReducer,
    faq: faqReducer,
    policy: policyReducer,
    contact: contactReducer,
    collection: collectionReducer,
    promoBanner: promoBannerReducer,
    courier: courierReducer,
    watchBuy: watchBuyReducer,
  },
});